// extracted by mini-css-extract-plugin
export default {"section":"Section_section__uMVRh","header":"Section_header__2A7pj","expanded":"Section_expanded__3blMc","headerControls":"Section_headerControls__qzzO1"};